import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useSwiper } from '../hooks/useSwiper';
import FsLightbox from "fslightbox-react";
import BlogSidebar from './BlogSidebar';
import blogPosts from '../data/blog-posts';

const BlogMain = () => {
    const swiperRef = useSwiper();
    const [toggler, setToggler] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const postsPerPage = 3;
    const totalPages = Math.max(1, Math.ceil(blogPosts.length / postsPerPage));
    const indexOfLast = currentPage * postsPerPage;
    const indexOfFirst = indexOfLast - postsPerPage;
    const currentPosts = blogPosts.slice(indexOfFirst, indexOfLast);
    const { t } = useTranslation();

    return (
    <>
      <section className="ot-blog-wrapper position-relative space-top space-extra-bottom overflow-hidden">
        <div className="bg-gradient-shape1" />
        <div className="bg-gradient-shape1 bg-gradient-shape2" />
        <div className="container">
            <div className="row">
            <div className="col-xxl-8 col-lg-8">
                {currentPosts.map((post) => (
                <div key={post.id} className="ot-blog blog-single has-post-thumbnail">
                    {post.postType === 'normal' && (
                        <div className="blog-img">
                            <Link to={`/blog/${post.slug}`}>
                                <img src={post.detailImage} alt={post.title} />
                            </Link>
                        </div>
                    )}

                    {post.postType === 'video' && (
                        <div className="blog-img">
                            <Link to={`/blog/${post.slug}`}>
                                <img src={post.detailImage} alt={post.title} />
                            </Link>
                            <a 
                                href="#"
                                onClick={(e) => {
                                e.preventDefault();
                                setToggler(!toggler);
                                }}
                                className="play-btn"
                            >
                                <i className="fas fa-play"></i>
                            </a>
                            
                            <FsLightbox
                                toggler={toggler}
                                sources={[post.videoUrl]}
                            />
                        </div>
                    )}

                    {post.postType === 'gallery' && (
                        <div className="blog-img">
                            <div ref={swiperRef} className="ot-react-slider" data-slider-options='{"effect":"fade"}'>
                                <div className="swiper-wrapper">
                                    {post.detailImage && post.detailImage.map((img, idx) => (
                                        <div key={idx} className="swiper-slide" data-opacity="5" data-overlay="black">
                                            <Link to={`/blog/${post.slug}`}>
                                                <img src={img} alt={post.title} />
                                            </Link>
                                        </div>
                                    ))}
                                </div>
                                <button className="slider-arrow slider-prev"><i className="far fa-angle-left" /></button>
                                <button className="slider-arrow slider-next"><i className="far fa-angle-right" /></button>
                            </div>
                        </div>
                    )}
                     <div className="blog-content">
                        <div className="blog-meta">
                        <Link className="author" to="/blog">
                            <i className="fas fa-user" />
                            {t('sections.blogMain.by','BY')} {t(`sections.blogPosts.post_${post.id}.author`, post.author)}
                        </Link>
                        <Link to="/blog">
                            <i className="fas fa-calendar-days" />
                            {t(`sections.blogPosts.post_${post.id}.date`, post.date)}
                        </Link>
                        </div>
                        <h2 className="blog-title">
                        <Link to={`/blog/${post.slug}`}>
                            {t(`sections.blogPosts.post_${post.id}.title`, post.title)}
                        </Link>
                        </h2>
                        <p className="blog-text">{t(`sections.blogPosts.post_${post.id}.excerpt`, post.excerpt)}</p>
                        <Link to={`/blog/${post.slug}`} className="ot-btn">
                        {t('sections.blogMain.read_details','Read Details')}
                        <i className="far fa-long-arrow-right ms-2" />
                        </Link>
                    </div>
                </div>
                ))}
                <div className="ot-pagination ">
                <ul>
                    <li>
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            if (currentPage > 1) setCurrentPage(currentPage - 1);
                        }}
                        data-cue="slideInUp"
                        aria-label={t('sections.blogMain.previous_page','Previous Page')}
                    >
                        <i className="far fa-angle-left" />
                    </a>
                    </li>
                    {Array.from({ length: totalPages }).map((_, i) => {
                    const page = i + 1;
                    return (
                        <li key={page}>
                        <a
                            href="#"
                            data-cue="slideInUp"
                            className={currentPage === page ? 'active' : ''}
                            onClick={(e) => {
                                e.preventDefault();
                                setCurrentPage(page);
                            }}
                            aria-label={`${t('sections.blogMain.page','Page')} ${page}`}
                        >
                            {page}
                        </a>
                        </li>
                    );
                    })}
                    <li>
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            if (currentPage < totalPages) setCurrentPage(currentPage + 1);
                        }}
                        data-cue="slideInUp"
                        aria-label={t('sections.blogMain.next_page','Next Page')}
                    >
                        <i className="far fa-angle-right" />
                    </a>
                    </li>
                </ul>
                </div>
            </div>
            <div className="col-xxl-4 col-lg-4 sidebar-wrap">
                <BlogSidebar />
            </div>
            </div>
        </div>
    </section>

    </>
  );
};

export default BlogMain;